import {
    AfterViewInit,
    Component,
    ElementRef,
    OnInit,
    ViewChild,
} from '@angular/core';

import { PartnersNamePipe } from '../../_shared/partners-name.pipe';
import { Partner, PartnerService } from '../../../_services';
import { TranslatePipe } from '@ngx-translate/core';
import { ToasterService } from '../../_shared/toaster/toaster.service';

@Component({
    selector: 'jhi-partners',
    templateUrl: './partner.component.html',
    styleUrls: ['./partner.component.scss'],
    providers: [PartnersNamePipe, TranslatePipe],
})
export class PartnerComponent implements OnInit, AfterViewInit {
    private static _search: string = '';

    @ViewChild('searchInput')
    private searchInput: ElementRef;

    account: any;
    error: string;
    success: string;
    partners: Partner[];
    active: boolean = true;

    constructor(
        private partnersService: PartnerService,
        private toasterService: ToasterService
    ) {}

    get search(): string {
        return PartnerComponent._search;
    }

    set search(search: string) {
        PartnerComponent._search = search;
    }

    ngOnInit() {
        this.fetchPartners();
    }

    ngAfterViewInit(): void {
        this.searchInput.nativeElement.focus();
    }

    fetchPartners(): void {
        this.partnersService.findAll().subscribe((partners) => {
            this.partners = partners.sort((p1, p2) =>
                p1.name.localeCompare(p2.name)
            );
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/directory/partner/partner.component.ts